import {
	type SlackChannelsResponse,
	type SlackChannelMembersResponse,
	type UserRequestModel,
	type SlackUserDetailsAndPermsResponse,
} from '../types';
import {
	DEFAULT_STARGATE_SERVICE_URL,
	ITPT_PATH,
	ITPT_SLACK_CHANNELS,
	ITPT_SLACK_CHANNEL_MEMBERS,
	ITPT_SLACK_USERS_DETAILS,
} from './common';
import { postJson, fetchJson } from './helpers';

export class InviteThirdPartyTeamsClient {
	async listSlackChannels(workspaceId: string, cursor?: string): Promise<SlackChannelsResponse> {
		return fetchJson<SlackChannelsResponse>(
			`${DEFAULT_STARGATE_SERVICE_URL}${ITPT_PATH}${ITPT_SLACK_CHANNELS}?workspaceId=${workspaceId}${
				cursor ? `&cursor=${cursor}` : ''
			}`,
			'listSlackChannels',
		);
	}

	async getSlackChannelMembers(
		workspaceId: string,
		channelId: string,
	): Promise<SlackChannelMembersResponse> {
		return fetchJson<SlackChannelMembersResponse>(
			`${DEFAULT_STARGATE_SERVICE_URL}${ITPT_PATH}${ITPT_SLACK_CHANNEL_MEMBERS}?workspaceId=${workspaceId}&channelId=${channelId}`,
			'getSlackChannelMembers',
		);
	}

	async getSlackUserDetailsAndPerms(
		tenantId: string,
		workspaceId: string,
		product: string,
		users: UserRequestModel[],
	): Promise<SlackUserDetailsAndPermsResponse> {
		return await postJson<SlackUserDetailsAndPermsResponse>(
			`${DEFAULT_STARGATE_SERVICE_URL}${ITPT_PATH}${ITPT_SLACK_USERS_DETAILS}`,
			'getSlackUserDetailsAndPerms',
			{ tenantId, workspaceId, product, users },
		);
	}
}
